module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.propsAnalise.fep) ? _c('router-link', {
    staticClass: "btn btn-primary btn-sm btn-flat",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "to": {
        name: 'relatorio-fep',
        params: {
          id: _vm.propsAnalise.id
        },
        props: {
          propsRel: _vm.propsAnalise
        }
      },
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  FEP")]) : _vm._e(), _vm._v(" "), (_vm.propsAnalise.fep) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-2",
    class: {
      'has-error': _vm.errors.first('numeroFEP')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Número da FEP:")]), _vm._v("\n      " + _vm._s(_vm.propsAnalise.fep.ano) + "/" + _vm._s(_vm.propsAnalise.fep.numero) + "\n      ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('dl', [_c('dd', [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('título do projeto')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Título do Projeto")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propsAnalise.ds_nome),
      expression: "propsAnalise.ds_nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "título do projeto",
      "type": "text",
      "maxlength": "255",
      "placeholder": "Título do Projeto",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.propsAnalise.ds_nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propsAnalise, "ds_nome", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('título do projeto')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('título do projeto')))]) : _vm._e()])]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('participantes diretos')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Participantes Diretos")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.participantesDiretos),
      expression: "participantesDiretos"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "participantes diretos",
      "type": "text",
      "maxlength": "255",
      "placeholder": "Participantes Diretos",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.participantesDiretos)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.participantesDiretos = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.first('participantes diretos')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('participantes diretos')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('dl', [_c('dd', [_c('div', {
    staticClass: "form-group required-field col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Objetivo Geral")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propsAnalise.ds_objetivo_geral),
      expression: "propsAnalise.ds_objetivo_geral"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "objetivo geral",
      "type": "text",
      "placeholder": "Objetivo Geral",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.propsAnalise.ds_objetivo_geral)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propsAnalise, "ds_objetivo_geral", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('orçamento')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Orçamento")]), _vm._v(" "), _c('money', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "orçamento",
      "type": "text",
      "maxlength": "255",
      "readonly": ""
    },
    model: {
      value: (_vm.totalFBB),
      callback: function($$v) {
        _vm.totalFBB = $$v
      },
      expression: "totalFBB"
    }
  }), _vm._v(" "), (_vm.errors.first('orçamento')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('orçamento')))]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('dl', [_c('dd', [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('proponente')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Proponente")]), _vm._v(" "), (_vm.propsAnalise.entidade) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propsAnalise.entidade.ds_nome),
      expression: "propsAnalise.entidade.ds_nome"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:255'),
      expression: "'required|max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "proponente",
      "type": "text",
      "maxlength": "255",
      "placeholder": "Proponente",
      "readonly": ""
    },
    domProps: {
      "value": (_vm.propsAnalise.entidade.ds_nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.propsAnalise.entidade, "ds_nome", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.errors.first('proponente')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('proponente')))]) : _vm._e()])]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('tipo de ação')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Tipo de Ação")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propsAnalise.ds_fep_tipo_acao),
      expression: "propsAnalise.ds_fep_tipo_acao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "tipo de ação",
      "aria-hidden": "true"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.propsAnalise, "ds_fep_tipo_acao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.fep.actionTypes), function(i) {
    return _c('option', {
      domProps: {
        "value": i.code
      }
    }, [_vm._v(_vm._s(i.description))])
  }), 0), _vm._v(" "), (_vm.errors.first('tipo de ação')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('tipo de ação')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('dl', [_c('dd', [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('cnpj')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("CNPJ")]), _vm._v(" "), (_vm.propsAnalise.entidade) ? _c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "cnpj",
      "mask": ['NN.NNN.NNN/NNNN-##'],
      "tokens": _vm.$cnpjTokens,
      "readonly": ""
    },
    model: {
      value: (_vm.propsAnalise.entidade.ds_cnpj),
      callback: function($$v) {
        _vm.$set(_vm.propsAnalise.entidade, "ds_cnpj", $$v)
      },
      expression: "propsAnalise.entidade.ds_cnpj"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.errors.first('cnpj')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('cnpj')))]) : _vm._e()], 1)]), _vm._v(" "), _c('dd', [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('abrangencia')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Abrangência Nacional")]), _vm._v(" "), _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.propsAnalise.bt_fep_abrangencia),
      expression: "propsAnalise.bt_fep_abrangencia"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "abrangencia"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.propsAnalise, "bt_fep_abrangencia", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Não")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("Sim")])])]), _vm._v(" "), (_vm.errors.first('abrangencia')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('abrangencia')))]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('parecer')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Parecer")]), _vm._v(" "), _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "name": "parecer"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.propsAnalise.ds_fep_parecer),
      callback: function($$v) {
        _vm.$set(_vm.propsAnalise, "ds_fep_parecer", $$v)
      },
      expression: "propsAnalise.ds_fep_parecer"
    }
  }), _vm._v(" "), (_vm.errors.first('parecer')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('parecer')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required-field col-md-12",
    class: {
      'has-error': _vm.errors.first('observacao')
    }
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Observações")]), _vm._v(" "), _c('textarea-autosize', {
    directives: [{
      name: "resizable",
      rawName: "v-resizable"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "name": "observacao"
    },
    on: {
      "input": _vm.resizable
    },
    model: {
      value: (_vm.propsAnalise.ds_fep_observacao),
      callback: function($$v) {
        _vm.$set(_vm.propsAnalise, "ds_fep_observacao", $$v)
      },
      expression: "propsAnalise.ds_fep_observacao"
    }
  }), _vm._v(" "), (_vm.errors.first('observacao')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('observacao')))]) : _vm._e()], 1)])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border",
    staticStyle: {
      "background-color": "#FCFCFC"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("FEP")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ce974ae8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/fep.vue
// module id = 2081
// module chunks = 1